<script setup lang="ts">
import type { NuxtError } from '#app'

import AppLayout from '@/components/layout/AppLayout.vue'
import StandardLayout from '@/components/layout/Layout.vue'
import Typography from '@/components/common/Typography.vue'
import ImageWithCaption from '@/components/common/ImageWithCaption.vue'

const { error } = defineProps({
  error: {
    type: Object as () => NuxtError,
    default: () => ({}),
  },
})

const { t } = useI18n()

const notFound = computed(() => error.statusCode === 404)
const title = computed(() => notFound.value ? t('error.notFound.title') : t('error.fatal.title'))
const text = computed(() => notFound.value ? t('error.notFound.text') : t('error.fatal.text'))

useHead({
  titleTemplate: title.value,
})
</script>

<template>
  <StandardLayout>
    <AppLayout>
      <div class="wrapper">
        <ImageWithCaption
          v-if="notFound"
          src="/404.webp"
          :caption="{ xhtml5output: 'Bilde av et tomt klasserom' }"
          alt-text="Bilde av et tomt klasserom"
          copyright="Foto av Guilia Squillace / Unsplash+"
          class="image"
        />
        <ImageWithCaption
          v-else
          src="/500.webp"
          :caption="{ xhtml5output: 'Knuste vintage briller på en denimbakgrunn' }"
          alt-text="Knuste vintage briller på en denimbakgrunn"
          copyright="Foto av delihayat / iStock"
          class="image"
        />

        <Typography
          component="h1"
          variant="h2"
        >
          {{ title }}
        </Typography>
        <Typography>{{ text }}</Typography>

        <CommonButton to="/">
          {{ $t('error.goToHomepage') }}
        </CommonButton>
      </div>
    </AppLayout>
  </StandardLayout>
</template>

<style lang="scss" scoped>
  .wrapper {
    width: $vgs-max-width-content;
    margin: 0 auto;
    color: var(--color-blue-50);

    .image {
      margin-bottom: 42px;
    }
  }
</style>
